import React, { useState } from 'react';

export default function Calendar({ onMonthChange }: any) {
    const currentMonth = new Date().getMonth() + 1;
    const currentYear = new Date().getFullYear();
    const [selectedMonth, setSelectedMonth] = useState(currentMonth);
    const [selectedYear, setSelectedYear] = useState(currentYear);

    const handleMonthChange = (event: any) => {
        const [month, year] = event.target.value.split('-').map(Number);
        setSelectedMonth(month);
        setSelectedYear(year);
        onMonthChange(month, year);
    };

    const handleYearChange = (event: any) => {
        setSelectedYear(parseInt(event.target.value));
        onMonthChange(selectedMonth, selectedYear);
    };

    const selectStyles = {
        backgroundColor: 'transparent',
        border: 'none',
        outline: 'none',
        fontSize: 'inherit',
        padding: '0',
        margin: '0',
        fontFamily: 'inherit',
        cursor: 'pointer',
    };

    return (
        <div style={{ display: 'inline-block', }}>
            <select
                style={selectStyles}
                value={`${selectedMonth}-${selectedYear}`}
                onChange={handleMonthChange}
            >
                {Array.from({ length: currentMonth }, (_, index) => (
                    <option key={index} value={`${index + 1}-${currentYear}`}>
                        {new Date(0, index).toLocaleString('default', { month: 'long' })} {currentYear}
                    </option>
                ))}
            </select>
        </div>
    );
}
